import { render, staticRenderFns } from "./material-rack.vue?vue&type=template&id=406fff2a&scoped=true"
import script from "./material-rack.vue?vue&type=script&lang=js"
export * from "./material-rack.vue?vue&type=script&lang=js"
import style0 from "./material-rack.vue?vue&type=style&index=0&id=406fff2a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406fff2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('406fff2a')) {
      api.createRecord('406fff2a', component.options)
    } else {
      api.reload('406fff2a', component.options)
    }
    module.hot.accept("./material-rack.vue?vue&type=template&id=406fff2a&scoped=true", function () {
      api.rerender('406fff2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/main-data/material-rack/material-rack.vue"
export default component.exports